import { render, staticRenderFns } from "./tipoPromocion.vue?vue&type=template&id=d387894a&scoped=true&"
import script from "./tipoPromocion.vue?vue&type=script&lang=js&"
export * from "./tipoPromocion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d387894a",
  null
  
)

export default component.exports